export default __webpack_public_path__ + "static/media/bannerBg.429fd545.png";